import React from "react";
import "./style.css";

const tools = [
    {
        title: "Reverse Image Search",
        description:
            "Upload any product photo, and AI instantly finds the exact or similar suppliers worldwide.",
    },
    {
        title: "Smart Product Matching",
        description:
            "AI recommends alternative suppliers and products with better pricing, quality, and faster shipping.",
    },
    {
        title: "Demand Forecasting",
        description:
            "Predicts product demand based on market trends, seasonal patterns, and sales data.",
    },
    {
        title: "Powered Cost Estimation",
        description:
            "Automatically calculates landed costs (product price, customs, duties, logistics, GST).",
    },
    {
        title: "Supplier Verification & Trust Score",
        description:
            "AI scan supplier history, reviews, fulfillment rates, and certification to assign a trust score.",
    },
    {
        title: "Assisted Marketplace Listings",
        description:
            "Auto-generate optimized product listings for Shopify, Amazon, and Flipkart with title, description, keywords, and images.",
    },
];

export default function AiComponent() {
    const columns = [
        [tools[0], tools[1]], // left
        [tools[2], tools[3]], // center
        [tools[4], tools[5]], // right
    ];

    return (
        <div className="container_ai">
            <h2 className="heading">AI Tools For <span className="imp-brand">importerr.com</span></h2>
            <p className="subheading">Leverage artificial intelligence to streamline your import business</p>

            <div className="layout_ai">
                {columns.map((col, i) => (
                    <div
                        key={i}
                        className={`column ${i === 1 ? "center-column" : ""}`}
                    >
                        {col.map((tool, j) => (
                            <div key={j} className="card_ai">
                                {/* <div className="card-icon">AI</div> */}
                                <h3>{tool.title}</h3>
                                <p>{tool.description}</p>
                                <div className="card-border"></div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
